import Cookies from "js-cookie"
import { jwtDecode } from "jwt-decode"

import { useContext } from "react"
import { AuthContext } from "../context/AuthProvider"
import type { PUser } from "../types/Types"



export type AuthRole = "oppenheimer_user"


export const useAuth = () => {

	const authContext = useContext(AuthContext)

  	if (!authContext) {
    	throw new Error("useAuth must be used within a AuthContext")
  	}

	const getUserJWT = () => {
		const jwtToken = Cookies.get("hodor-token")
		if (!jwtToken) throw new Error("JWT is missing")

		const decoded: any = jwtDecode(jwtToken);
		if (!decoded) throw new Error("Invalid JWT")

		return decoded
	}

	const loadUserFromJWT = (): PUser => {
		const token = getUserJWT()

		return {
			email: token.email,
			full_name: token.full_name,
			groups: token.groups,
			roles: token.roles,
			expiration: token.exp,
		}
	}

	const getCurrentUser = (): PUser | undefined => {
		try {
			let user = authContext.user;

			if (!user) {
				user = loadUserFromJWT()
			}

			if (!user) {
				return undefined
			}

			// if (user.expiration * 1000 < Date.now()) {
			// 	console.log("Token expired")
			// 	return undefined
			// }

			return user
		} catch (e) {
			console.log(e)
			return undefined
		}
	}

  	const validSession = () => getCurrentUser() != undefined

	const userHasPermissions = (roles: AuthRole[]): boolean => {
		try {
			const user = getCurrentUser()
			if (!user) throw new Error("Invalid user")

			return roles.some((role) => user.roles?.includes(role));
		} catch (e) {
			console.log(e)
			return false
		}
	}

	const logout = () => {
		authContext.setUser(undefined)
		Cookies.remove("hodor-token")
		Cookies.remove("hodor-refresh")
  	}

	return {
		user: authContext.user,
		setUser: authContext.setUser,
		getCurrentUser,
		validSession,
		userHasPermissions,
		logout,
	}
}